// extracted by mini-css-extract-plugin
export default {"container":"styles_container__1Luqf","image":"styles_image__VG32x","hints":"styles_hints__2eAyL","action":"styles_action__n9ZfC"};